import type { BaseBlock } from "@/react/components/shared/BuilderUI/DataModel.types";

export const defaultData: BaseBlock = {
  id: "form-contact-email-block",
  type: "FormContactEmailBlock",
  props: {
    label: {
      prop: "other",
      type: "string",
      value: "Email",
    },
    placeholder: {
      prop: "other",
      type: "string",
      value: "",
    },
  },
};
